<template>
  <section class="static-text">
    <div class="static-text__info">
      <h3>оставьте заявку отделу заботы&nbsp;— мы&nbsp;ответим на&nbsp;любые вопросы</h3>
      <a
        :href="$getTelegramLink($route)"
        target="_blank"
      >
        <span>задать вопрос</span>
        <img
          src="/v2/school-university/faq/tg.svg"
          alt="telegram"
          loading="lazy"
        >
      </a>
    </div>

    <div class="static-text__text">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'ForStaticText',
};
</script>

<style scoped lang="scss">
.static-text {
  display: flex;
  justify-content: space-between;
  padding: calc(var(--scale) * 24) calc(var(--scale) * 40);
  background-color: #FFFFFF;
  border-radius: calc(var(--scale) * 60);

  @include media-down($size-tablet) {
    padding: calc(var(--scale) * 20) calc(var(--scale) * 16) calc(var(--scale) * 16);
    border-radius: calc(var(--scale) * 32);
  }

  @include media-down($size-mobile) {
    flex-direction: column-reverse;
    gap: calc(var(--scale) * 40);
    position: relative;
  }

  &__info {
    width: calc(var(--scale) * 560);
    flex-shrink: 0;

    @include media-down($size-tablet) {
      width: 33.4rem;
    }

    @include media-down($size-mobile) {
      width: 100%;
    }

    h3 {
      margin-bottom: calc(var(--scale) * 20);

      font-style: normal;
      font-weight: 500;
      font-size: calc(var(--scale) * 32);
      line-height: 110%;
      color: #02120F;

      @include media-down($size-tablet) {
        line-height: 110%;
        font-size: calc(var(--scale) * 18);
      }
    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;

      width: calc(var(--scale) * 299);
      height: calc(var(--scale) * 72);

      background-color: #2193CC;
      border-radius: calc(var(--scale) * 24);
      transition: 200ms;

      @include media-down($size-tablet) {
        width: 24rem;
        height: 7.2rem;
        border-radius: 2.4rem;
      }

      @include media-down($size-mobile) {
        margin-top: 2rem;
        width: 100%;
      }

      @media (hover: hover) {
        &:hover {
          background-color: #1A84B9;
        }
      }

      span {
        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: #FFFFFF;

        @include media-down($size-tablet) {
          font-size: 2rem;
          line-height: 110%;
          letter-spacing: -0.02em;
        }
      }

      img {
        width: calc(var(--scale) * 44);
      }
    }
  }

  &__text {
    width: calc(var(--scale) * 870);

    @include media-down($size-tablet) {
      width: calc(var(--scale) * 348);
    }

    @include media-down($size-mobile) {
      width: 100%;
    }

    h1 {
      margin-bottom: calc(var(--scale) * 12);
      font-weight: 500;
      font-size: calc(var(--scale) * 48);
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        margin-bottom: calc(var(--scale) * 8);
        font-size: calc(var(--scale) * 20);
      }
    }

    h2,
    h4 {
      margin-bottom: calc(var(--scale) * 12);
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #02120F;

      @include media-down($size-tablet) {
        margin-bottom: calc(var(--scale) * 8);
        font-size: calc(var(--scale) * 18);
      }
    }

    p {
      font-weight: 400;
      font-size: 20px;
      line-height: 130%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 16);
      }

      &:not(:last-child) {
        margin-bottom: calc(var(--scale) * 32);

        @include media-down($size-tablet) {
          margin-bottom: calc(var(--scale) * 20);
        }
      }
    }

    span {
      color: #02120F;
    }

    a {
      color: inherit;

      &:hover {
        text-decoration: underline;
      }
    }

    ol {
      margin-top: calc(var(--scale) * 10);
      list-style-type: disc;
      padding-left: 1.5em;
    }
  }
}
</style>
